<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'TemplateViewPages'
}
</script>

<style>
* {
  font-family: 'Poppins', sans-serif;
}
.bg-mx-green {
  background-color: #00AFB9;
}
.bg-mx-blue-green {
  background-color: #00899F;
}
.border-mx-green {
  border-color: #00AFB9;
}
.text-mx-green {
  color: #00AFB9;
}
.text-mx-blue-green {
  color: #00899F;
}
.hover-mx-green:hover {
  background-color: #00AFB9;
}
</style>
